<template>
      <div class="floating__text" v-bind:class="floatingColors">
        <p>ALL ABOUT YOUR BRAND</p>
      </div>
</template>

<script>
export default {
  name: "FloatingText",
  data() {
    return {};
  },
    props: ["floatingColors"]
};
</script>



// WEBPACK FOOTER //
// src/components/small-components/FloatingText.vue